import { render, staticRenderFns } from "./blame_info.vue?vue&type=template&id=dbcc3526&scoped=true"
import script from "./blame_info.vue?vue&type=script&lang=js"
export * from "./blame_info.vue?vue&type=script&lang=js"
import style0 from "./blame_info.vue?vue&type=style&index=0&id=dbcc3526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcc3526",
  null
  
)

export default component.exports